import { useState } from 'react';
import apiClient from '../../services/apiClientService';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

/**
 * One call of the email + password sign-in, `path` being what follows `…/auth/`. `send` returns the
 * response body, `true` for an empty one, or `null` after a failure, which the snackbar shows with
 * the backend's message.
 */
const useAuthRequest = (path) => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const send = async (body) => {
    setLoading(true);
    try {
      const response = await apiClient.post(`/v1/public/tenants/${tenantId}/auth/${path}`, body);
      return response?.data || true;
    } catch (error) {
      // No return route: a wrong password is not an expired session, so nothing sends the guest to /login.
      handleError(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { send, loading };
};

export default useAuthRequest;
